import Header from './components/Header';
import Hero from './components/Hero';
import Contact from './components/Contact';
import IndexSection from './components/IndexSection';
import Ranking from './components/Ranking';
import About from './components/About';
import AppSection from './components/AppSection';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import Features from './components/Features';
import Topics from './components/Topics';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Contact />
        <IndexSection />
        <Ranking />
        <About />
        <AppSection />
        <FAQ />
        <Media />
        <Carousel />
        <Comments />
        <Features />
        <Topics />
        <Updates />
        <Cards />
      </main>
      <Footer />
    </div>
  );
}